import { truncateText } from "@/utility/truncateText";

export default {
  data() {
    return {
      oldPages: [],
      showAllPageChips: false,
      showAddPageDialog: false,
    };
  },
  computed: {
    getPageArray() {
      return this.showAllPageChips ? this.form.pages : this.form.pages.slice(0, 12);
    },
  },
  methods: {
    getPageName(page) {
      return truncateText(page.slug);
    },
    openPageEdit(page) {
      const id = page["@id"]?.split("/").pop();
      if (!id) return;
      const route = this.$router.resolve({ name: "pages_edit", params: { id } });
      window.open(route.href, "_blank");
    },
    syncPages(pages) {
      this.form.pages = pages;
      this.oldPages = pages;
    },
    removePage(page) {
      this.syncPages(this.form.pages.filter(item => item["@id"] !== page["@id"]));
    },
  },
};
